
export default class VisualPositioningManager {
    horizontalDivisions     : number
    verticalDivisions       : number

    blocks                  : any
    blockTargets            : any
    components              : any

    rectRetrievalFunction   : func

    constructor(horizontalDivisions = 1, verticalDivisions = 1) {
        this.horizontalDivisions = horizontalDivisions;
        this.verticalDivisions = verticalDivisions;

        this.blocks = {}
        this.blockTargets = {};

        this.components = null;

        this.rectRetrievalFunction = ()=>({
            left:   0,
            top:    0,
            right:  0,
            bottom: 0
        });
    }

    init(components: any, rectRetrievalFunction: func) {
        this.components = components;

        const horizontalBlockWidth = window.innerWidth / this.horizontalDivisions;
        const verticalBlockWidth = window.innerHeight / this.verticalDivisions;

        for(let i=1; i<=this.verticalDivisions; i++) {
            for(let j=1; j<=this.horizontalDivisions; j++) {
                this.blocks[i+'_'+j] = {
                    left:   horizontalBlockWidth * (i - 1),
                    top:    verticalBlockWidth * (j - 1),
                    right:  horizontalBlockWidth * i,
                    bottom: verticalBlockWidth * j
                };
            }
        }

        this.rectRetrievalFunction = rectRetrievalFunction;
    }

    collectBlockTargets() {
        for(let i=1; i<=this.verticalDivisions; i++) {
            for(let j=1; j<=this.horizontalDivisions; j++) {
                this.blockTargets[i+'_'+j] = [];
            }
        }

        _.map(this.components, c=>{
            const tRect = this.rectRetrievalFunction(c);
            _.mapKeys(this.blocks, (blockRect, key)=>{
                if (this.__isIntersecting(blockRect, tRect)) this.blockTargets[key].push(c);
            });
        });
    }

    addTarget(targetComponent: any) {
        if (!this.components) return;
        this.components.push(targetComponent)

        const tRect = this.rectRetrievalFunction(targetComponent);
        _.mapKeys(this.blocks, (blockRect, key)=>{
            if (this.__isIntersecting(blockRect, tRect)) this.blockTargets[key].push(targetComponent);
        });
    }

    removeTarget(targetComponent: any) {
        if (!this.components) return;
        this.components.remove(targetComponent)

        _.mapKeys(this.blockTargets, (blockTargets, key)=>{
            blockTargets.remove(targetComponent);
        });
    }

    getAppropriateBlock(mouseEvent: any) {
        let res: any[] = [];
        _.mapKeys(this.blocks, (blockRect, key)=>{
            if (this.__isInside(mouseEvent, blockRect)) res = this.blockTargets[key];
        });

        return res;
    }

    addWindowListeners() {
        window.addEventListener('scroll', this.onScroll, true)
    }

    removeWindowListeners() {
        window.removeEventListener("scroll", this.onScroll, true);
    }

    onScroll = () => {
        this.collectBlockTargets();
    }

    __isIntersecting(r1: any, r2: any) {
        return !(   r2.left     > r1.right  ||
                    r2.right    < r1.left   ||
                    r2.top      > r1.bottom ||
                    r2.bottom   < r1.top    );
    }

    __isInside(m: any, t: any) {
        return !(   m.clientX < t.left   ||
                    m.clientX > t.right  ||
                    m.clientY < t.top    ||
                    m.clientY > t.bottom);
    }

    flush() {
        this.components = null;
    }
}